import { render, staticRenderFns } from "./kpi-owner-query.vue?vue&type=template&id=3b1285e0"
import script from "./kpi-owner-query.vue?vue&type=script&lang=js"
export * from "./kpi-owner-query.vue?vue&type=script&lang=js"
import style0 from "./kpi-owner-query.vue?vue&type=style&index=0&id=3b1285e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports